module.exports = __webpack_public_path__ + "img/20220219_072300.25e61f10.jpg";